import { RefactoredDevice } from '../../../@types/model/device';
import BarDeliver from './pieces/BarDeliver';
import { useTranslation } from 'react-i18next';
import { DeliverFilter } from '../../../@types/model/deliver';
import '../../../assets/css/newDeliver.scss';
import { useEffect, useState } from 'react';

type DeliveryBarProps = {
  rd: RefactoredDevice;
  unit: string;
  tableFilter: DeliverFilter;
  percentSlots: number;
  percentInitial: number;
  extraPercentage: number;
  amountSlots: number;
};

const DeliveryBar = (props: DeliveryBarProps) => {
  const { t } = useTranslation();

  const [percent, setPercent] = useState(0);
  const [extraPercentage, setExtraPercentage] = useState(0);
  const [percentInitial, setPercentInitial] = useState(0);
  const [percentActualBackground, setPercentActualBackground] = useState(0);

  useEffect(() => {
    let percent = props.rd.percent;
    let extraPercentage = props.extraPercentage;
    let percentInitial = props.percentInitial;
    // Si tenemos solicitud de suministro infinitas, y hay solicitudes de suministro pendientes, debemos permitir que hagan solicitudes completas, sin tener en cuenta el porcentage de ocupación del silo, y sin tener en cuenta el espacio extra.
    if (props.rd.productSchedule?.schedule) {
      if (props.rd.productSchedule?.schedule.length > 0) {
        if (props.rd.productSchedule?.schedule[0].infinite) {
          extraPercentage = 0;
          percentInitial = 0;
          setPercentActualBackground(props.percentInitial);
        }
      }
    }
    setExtraPercentage(extraPercentage);
    setPercent(percent);
    setPercentInitial(percentInitial);
  }, [props]);

  return (
    <BarDeliver className="barDeliver">
      {percentActualBackground > 0 ? (
        <div
          className="barDeliverDataBackground"
          style={{
            backgroundColor: props.rd.backgroundPercent,
            color: props.rd.colorPercent,
            width: percentActualBackground + '%'
          }}
        >
          {Math.round(props.rd.percent)}%
        </div>
      ) : (
        <div
          className="barDeliverData"
          style={{
            backgroundColor: props.rd.backgroundPercent,
            color: props.rd.colorPercent,
            width: percentInitial + '%'
          }}
        >
          {Math.round(props.rd.percent)}%
        </div>
      )}
      {props.amountSlots > 0 && (
        <div
          className="slotFill"
          style={{
            width: props.percentSlots + '%'
          }}
        >
          {props.amountSlots + props.unit}
        </div>
      )}
      <div
        className="barFull"
        style={{
          left: 100 / (1 + extraPercentage / 100) + '%',
          width: extraPercentage + '%'
        }}
      >
        100%
      </div>
      <span
        style={{
          position: 'absolute',
          bottom: '-15px',
          right: '0px',
          fontSize: '10px'
        }}
      >
        {t('capacity')} {props.rd.capacidad}
      </span>
    </BarDeliver>
  );
};
export default DeliveryBar;
